// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__mhAqY","container":"styles_container__1fmAk","title":"styles_title__2K312","wrapper":"styles_wrapper__XV-Ug","answer":"styles_answer__2jP73"};